import CustomButton from "@/shared/components/kit/button";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";

/**
 * GetPOSDevice
 *
 * این کامپوننت یک کارت معرفی برای ثبت درخواست دریافت دستگاه POS ارائه می‌دهد.
 *
 * قابلیت‌ها:
 * - نمایش عنوان بخش همراه با آیکن مرتبط.
 * - ارائه متن توضیحی درباره فرآیند درخواست دستگاه POS.
 * - نمایش دکمه فراخوان جهت انتقال کاربر به مرحله ثبت درخواست.
 * - طراحی واکنش‌گرا (Responsive) برای نمایش صحیح در موبایل و دسکتاپ.
 *
 * ساختار:
 * - بخش Header شامل آیکن و عنوان.
 * - بخش توضیحات شامل متن راهنما.
 * - بخش عملیاتی شامل دکمه "ثبت درخواست".
 *
 * @returns JSX.Element کامپوننت کارت معرفی دریافت دستگاه POS
 */

const GetPOSDevice = () => {
  return (
    <StackKit sx={{padding: { xs: "12px", sm: "17px" },height: "fit-content",width: "100%",boxSizing: "border-box",}} justifyContent={"space-between"} gap={2}>
      {/* Header */}
      <StackKit direction={{ xs: "column", sm: "row" }} justifyContent={{ xs: "flex-start", sm: "start" }} alignItems={{ xs: "flex-start", sm: "center" }} gap={1.5}>
        <LocalHospitalOutlinedIcon fontSize="small" />
        <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "14px", sm: "16px" }, lineHeight: 1.4 }}>
          دریافت دستگاه pos
        </TypoGraphyKit>
      </StackKit>

      {/* Description */}
      <TypoGraphyKit variant="body1" sx={{fontSize: { xs: "12px", sm: "14px" },lineHeight: 1.6,mt: { xs: 1, sm: 0 },}}>
        جهت دریافت دستگاه pos جدید برای فروشگاه خود ؛ درخواست خود را ثبت کنید.
      </TypoGraphyKit>

      {/* Button */}
      <StackKit alignItems={{ xs: "stretch", sm: "end" }} sx={{ paddingBlock: { xs: "10px", sm: "15px" }, width: "100%" }}>
        <CustomButton sx={{ width: { xs: "100%", sm: "auto" } }}>
          <TypoGraphyKit variant="body1">ثبت درخواست</TypoGraphyKit>
        </CustomButton>
      </StackKit>
    </StackKit>
  );
};

export default GetPOSDevice;
